import React from 'react';
import { Box, Container, Grid, Typography, Card, CardContent } from '@mui/material';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ScienceIcon from '@mui/icons-material/Science';

export const Page6: React.FC = () => {
    return (
        <Container maxWidth={false} sx={{ paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#fff' }}>
            <Typography
                variant="h2"
                sx={{
                    fontFamily: 'ClaireMurphy', // Apply your custom font
                    fontSize: {
                        xs: '30px',
                        sm: '40px',
                        md: '50px',
                    },
                    fontWeight: 400,
                    textAlign: 'center',
                    color: 'rgba(61, 61, 61, 1)',
                    marginBottom: '30px',
                }}
            >
                OUR PRODUCTS ARE
            </Typography>
            <Grid container spacing={4}>
                {[
                    {
                        id: 1,
                        icon: CenterFocusStrongIcon,
                        title: 'Targeted Solutions For Specific Skin Problems',
                        description: 'Our lines are aimed at solving specific skin problems using combinations of proven, effective ingredients in optimal concentrations for measurable results.',
                    },
                    {
                        id: 2,
                        icon: PrecisionManufacturingIcon,
                        title: 'Advanced Technology & High Activity',
                        description: 'We always put product effectiveness first. Our products feature advanced technology with high activity and concentration of active substances for professional-grade results.',
                    },
                    {
                        id: 3,
                        icon: ScienceIcon,
                        title: 'Innovative Formulas With Safe Penetration',
                        description: 'We ensure comfortable, safe formulas with appropriate penetration promoters that improve effectiveness. We create trends and leverage the latest innovations in cosmetology.',
                    },
                ].map((feature) => (
                    <Grid item xs={12} md={4} key={feature.id}>
                        <Card
                            sx={{
                                borderRadius: '20px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                padding: '20px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '100%', // Make the card take the full height of its container
                            }}
                        >
                            <CardContent
                                sx={{
                                    flexGrow: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start', // Align the content to the left
                                    textAlign: 'left', // Align the text to the left
                                }}
                            >
                                <Box sx={{ marginBottom: '20px', color: 'rgba(61, 61, 61, 1)' }}>
                                    {React.createElement(feature.icon, { sx: { fontSize: '50px' } })}
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontFamily: 'Quicksand',
                                        fontSize: '30px',
                                        fontWeight: 500,
                                        lineHeight: '36px',
                                        letterSpacing: '-0.02em',
                                        textAlign: 'left',
                                        color: 'rgba(61, 61, 61, 1)',
                                        marginBottom: '10px',
                                    }}
                                >
                                    {feature.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand',
                                        fontSize: '18px',
                                        fontWeight: 400,
                                        lineHeight: '22.5px',
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        marginTop: '30px',
                                        marginBottom: 'auto', // Pushes the content down
                                    }}
                                >
                                    {feature.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};
